<div class="min-h-screen px-4 py-8 md:px-8">
  <h1 class="text-primary mb-8 text-[28px] font-[700]" i18n="@@changeLanguageTitle">
    {{ isAr() ? "تغيير اللغة" : "Change Language" }}
  </h1>

  <div class="w-full rounded-[12px] bg-white p-8 shadow-[0px_0px_12px_1px_rgba(0,0,0,0.06)]">
    <div class="mb-4 flex items-center gap-2.5">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M8.125 21.213q-1.825-.788-3.187-2.15t-2.15-3.188T2 11.988t.788-3.875t2.15-3.175t3.187-2.15T12.013 2t3.875.788t3.175 2.15t2.15 3.175t.787 3.875t-.787 3.887t-2.15 3.188t-3.175 2.15t-3.875.787t-3.888-.787M12 19.95q.65-.9 1.125-1.875T13.9 16h-3.8q.3 1.1.775 2.075T12 19.95m-2.6-.4q-.45-.825-.787-1.713T8.05 16H5.1q.725 1.25 1.813 2.175T9.4 19.55m5.2 0q1.4-.45 2.488-1.375T18.9 16h-2.95q-.225.95-.562 1.838T14.6 19.55M4.25 14h3.4q-.075-.5-.112-.987T7.5 12t.038-1.012T7.65 10h-3.4q-.125.5-.187.988T4 12t.063 1.013t.187.987m5.4 0h4.7q.075-.5.113-.987T14.5 12t-.038-1.012T14.35 10h-4.7q-.075.5-.112.988T9.5 12t.038 1.013t.112.987m6.7 0h3.4q.125-.5.188-.987T20 12t-.062-1.012T19.75 10h-3.4q.075.5.113.988T16.5 12t-.038 1.013t-.112.987m-.4-6h2.95q-.725-1.25-1.812-2.175T14.6 4.45q.45.825.788 1.713T15.95 8M10.1 8h3.8q-.3-1.1-.775-2.075T12 4.05q-.65.9-1.125 1.875T10.1 8m-5 0h2.95q.225-.95.563-1.838T9.4 4.45Q8 4.9 6.912 5.825T5.1 8" />
      </svg>
      <span class="text-text-heading text-[18px] font-[600]">
        {{ isAr() ? "تغيير اللغة" : "Change Language" }}
      </span>
    </div>

    <div class="bg-bg mb-8 h-[1.5px]"></div>

    <form class="space-y-10" (ngSubmit)="onSave()">
      <div class="flex flex-col gap-2 md:w-1/2">
        <label class="text-text-hint text-[13px] font-[600] tracking-wide uppercase" i18n="@@selectLanguageLabel">
          {{ isAr() ? "اختر اللغة" : "Select Language" }}
        </label>

        <div class="relative w-full">
          <button
            type="button"
            (click)="toggleDropdown()"
            class="border-border-subtle text-text-body focus-border-primary flex w-full items-center justify-between border-b bg-transparent py-2.5 text-[15px] font-[500] transition-all outline-none">
            <div class="flex items-center gap-2">
              <span class="text-lg">{{ selectedLanguageItem()?.flag }}</span>
              <span>{{ isAr() ? selectedLanguageItem()?.labelAr : selectedLanguageItem()?.labelEn }}</span>
            </div>

            <svg
              [class]="dropdownOpen() ? 'rotate-180' : ''"
              class="h-5 w-5 text-gray-400 transition-transform"
              viewBox="0 0 20 20"
              fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
          </button>

          @if (dropdownOpen()) {
            <div
              class="absolute top-full left-0 z-10 mt-1 w-full rounded-[8px] border border-gray-100 bg-white p-1.5 shadow-lg">
              @for (lang of languages; track lang.id) {
                <button
                  type="button"
                  (click)="selectLanguage(lang.id)"
                  [class]="
                    selectedLanguageId() === lang.id ? 'bg-primary-5 text-primary' : 'text-gray-700 hover:bg-gray-50'
                  "
                  class="flex w-full items-center gap-2.5 rounded-[6px] px-4 py-2 text-left text-[14px] font-[500]">
                  <span class="text-lg">{{ lang.flag }}</span>
                  <span class="flex-1">{{ isAr() ? lang.labelAr : lang.labelEn }}</span>
                  @if (selectedLanguageId() === lang.id) {
                    <svg class="fill-primary" width="18" height="18" viewBox="0 0 24 24">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                    </svg>
                  }
                </button>
              }
            </div>
          }
        </div>
      </div>

      <div class="flex items-center gap-4 pt-4 md:ms-auto md:w-1/2 ltr:flex-row-reverse rtl:flex-row">
        <button
          type="submit"
          [disabled]="loading()"
          class="bg-primary hover-bg-primary-hover min-w-[140px] rounded-[8px] px-8 py-2.5 text-[14px] font-[600] text-white transition-all disabled:opacity-50">
          <div class="flex items-center justify-center gap-2">
            @if (loading()) {
              <span class="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white"></span>
            }
            <span i18n="@@save">
              {{ loading() ? (isAr() ? "جاري الحفظ..." : "Saving...") : isAr() ? "حفظ التغييرات" : "Save Changes" }}
            </span>
          </div>
        </button>

        <button
          type="button"
          (click)="onCancel()"
          i18n="@@cancel"
          class="border-primary text-primary hover-bg-primary-10 min-w-[140px] rounded-[8px] border px-8 py-2.5 text-[14px] font-[600] transition-all">
          {{ isAr() ? "إلغاء" : "Cancel" }}
        </button>
      </div>
    </form>
  </div>
</div>
